import React from 'react';
import BtnPrimary from "../../../../shared/ui/button/primary/BtnPrimary";
import ModalCustom from "../../../../shared/ui/modal/ModalCustom";

const ModalRestoreEmployeeConfirm = ({confirmHandler, closeHandler, data}: any) => {
    return (
        <ModalCustom title={"Conferma ripristino dipendente"} closeModal={closeHandler}
                     footerTemplate={<div className={'btn-row'}>
                         <BtnPrimary onClick={closeHandler}
                                     variant={'outline-primary'}
                                     className={'text-primary'}>Annulla</BtnPrimary>
                         <BtnPrimary onClick={confirmHandler}>Conferma</BtnPrimary>
                     </div>}>
            <p>Confermi il ripristino del dipendente {data?.name} {data?.surname}?</p>
        </ModalCustom>
    );
};

export default ModalRestoreEmployeeConfirm;
